import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { UUID } from "@/lib/types";

export function useSeriesTasks(seriesId: UUID | undefined) {
  return useQuery({
    queryKey: seriesId ? queryKeys.seriesTasks(seriesId) : ["meeting-series", "none", "tasks"],
    queryFn: () => api.listSeriesTasks(seriesId as UUID),
    enabled: !!seriesId,
  });
}
